<template>
    <div>
        <div
            v-if="!exports.length && !loading"
        >
            <p class="bg-red-100 dark:bg-red-800 dark:text-red-300 p-3 border-red-400 border rounded-md">
                No ranking exports found.
            </p>
        </div>

        <table
            v-if="exports.length"
            class="table-fixed min-w-full divide-y divide-gray-200 shadow dark:shadow-white my-4 text-black dark:text-white"
        >
            <thead>
                <th class="p-2 text-left">ID</th>
                <th class="p-2 text-left">Status</th>
                <th class="p-2 text-left">Message</th>
                <th class="p-2 text-left">File</th>
            </thead>

            <tbody>
            <tr
                v-for="(row, index) in exports"
                :key="`export-${index}`"
            >
                <td class="p-2">
                    {{ row.id }}
                </td>
                <td class="p-2">
                    {{ row.status }}
                </td>
                <td class="p-2">
                    {{ row.message }}
                </td>
                <td class="p-2">
                    <span v-if="row.download_route">
                        <a :href="row.download_route" target="_blank">
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 inline">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
                                </svg>
                            </span>
                        </a>

                        {{ row.filename }}
                    </span>
                    <span v-if="!row.download_route">
                        -
                    </span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import csrf from '../mixins/csrf'

export default {
    name: 'RankingExports',
    mixins: [csrf],
    data() {
        return {
            exports: [],
            loading: false,
        }
    },
    mounted: function () {
        this.getData();

        setInterval(() => {
            this.getData();
        }, 10000);
    },
    methods: {
        getData() {
            this.loading = true;

            axios
                .get(route('api.exports.rankings.index'))
                .then((response) => {
                    this.exports = response.data.data;
                })
                .catch((error) => {
                    console.error(error)
                }).finally(() => {
                    this.loading = false;
                });
        },
    },
}
</script>
